import { createCrumb } from './createCrumb';
import { generatePathnames } from './generatePathnames';

import type { Crumb } from 'features/Breadcrumbs/hooks/useBreadcrumbs/hooks/useCrumbs/types';

export const handleArrayCrumb = (
  title: string[],
  currentHandle: Function,
  pathname: string,
  acc: Crumb[],
  dynamicCrumb: any,
): Crumb[] => {
  const generatedPathnames = generatePathnames(pathname, title.length);

  const crumbs = title.map((string, i) =>
    createCrumb(
      currentHandle(string),
      generatedPathnames[i],
      dynamicCrumb[pathname]?.isLoading || false,
    ),
  );

  return [...acc, ...crumbs];
};
